'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
type ScrollSentinelProps = {
  onIntersect: () => void;
  height?: number;
};
export default function ScrollSentinel(t0) {
  const $ = _c(9);
  const {
    onIntersect,
    height: t1
  } = t0;
  const height = t1 === undefined ? 200 : t1;
  const [ref, inView] = useInView();
  let t2;
  let t3;
  if ($[0] !== inView || $[1] !== onIntersect) {
    t2 = () => {
      if (inView) {
        onIntersect();
      }
    };
    t3 = [inView, onIntersect];
    $[0] = inView;
    $[1] = onIntersect;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== height) {
    t4 = {
      height
    };
    $[4] = height;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== ref || $[7] !== t4) {
    t5 = <div ref={ref} className="pointer-events-none absolute bottom-0 left-0 right-0" style={t4} />;
    $[6] = ref;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}